<!--ADD ADDITIONAL METADATA MODAL STARTS-->

<app-modal [modalId]="'addAdditionalMetadata'" [modalContentId]="'addAdditionalMetadataContent'"
  [showCloseAlert]="addMetadataForm.dirty" [showDoneBtn]="true" [modalSize]="'big'" (closeEvent)="onCancel($event)">
  <modal-div class="title-text">
    Add {{option}}
  </modal-div>

  <modal-div class="body-content">
    <ng-container>
      <p>Fields marked with an asterisk (<span class="mandatory">*</span>) are
        required.
      </p>
      <p class="modal--info-txt font-bold" id="addAdditionalMetadataContent">You are adding {{option}} for the following
        node.
      </p>
      <div class="jumbotron mx-0">
        <div class="d-flex col-12" id="Container_{{ nodeDetails?.full_statement }}">
          <strong class="col-max-1 text-wrapped" [innerHtml]="nodeDetails?.human_coding_scheme"></strong>
          <span class="col-10 text-wrapped" [innerHtml]="fullStatement"></span>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row justify-content-between">
          <div class="col-md-7">
            <form [formGroup]="addMetadataForm">
              <div class="row">
                <div class="dropdown form-group col-lg-6">
                  <app-auto-complete [listingObj]="additionalMetaDataList" (selectedObject)="onMetadataSelected($event)"
                    [selectType]="selectType" [uniqueId]="uniqueId" [propName]="'name'"
                    [autoCompleteTitle]="autoCompleteTitle" #autoComplete>
                  </app-auto-complete>

                  <p id="associationTypeHelp" class="form-text text-muted text-right">Select the Key name of the
                    {{option?.toLowerCase()}}.</p>
                </div>
                <div class="form-group col-lg-6 custom_metadata">
                  <label for="customMetadataValue" class="font-bold" id="customMetadataValueLabel">Value <span
                      class="mandatory">*</span></label>
                  <app-dynamic-form-field name="metadataValue" ngDefaultControl
                    [formControl]="addMetadataForm.controls['metadataValue']" [field_type_id]="field_type_id"
                    [disabled]="selectedMetadata ? false : true" [ngModel]="currentValue ? currentValue : ''"
                    (ngModelChange)="currentValue=$event;checkCustomValidation()" [clearFieldValue]="true"
                    [selectedMetadata]="selectedMetadata"></app-dynamic-form-field>
                  <div class="error--txt"
                    *ngIf="addMetadataForm.controls['metadataValue'].hasError('required') && addMetadataForm.controls['metadataValue'].touched">
                    <div role="alert">
                      <p class="font-bold m-0 d-flex align-items-center mt-1">
                        <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                        Metadata Value Required
                     </p>
                    </div>
                  </div>
                  <p id="customMetadataValueHelp" class="form-text text-muted text-right">Enter the Value you'd want to
                    associate
                    with this Key.</p>
                </div>
              </div>

              <p class="mt-4">
                <button class="btn btn-primary" (click)="addMetaData($event)"
                  [disabled]="(checkFormValidation()===false) || (formValid===false)"
                  [class.disabled]="(checkFormValidation()===false) || (formValid===false)"
                  id="addAdditionalMetadataBtn">{{addedMetadataList
                  && addedMetadataList?.length ? 'Add another ' : 'Add '}} {{option?.toLowerCase()}}
                </button>
              </p>
            </form>
          </div>
          <aside class="col-md-4 file-panel">

            <section class="row" aria-labelledby="mappingID">
              <div class="col-12 file-panel-header">
                <h3 id="mappingID" class="mb-0 font-bold">{{option}}</h3>
              </div>

              <div *ngIf="checkFormValidation() === true" class="d-flex col-12 exemplar-listing">
                <div class="col-12 text-wrapped px-0 animate__animated animate__fadeIn animate__delay-2s">
                  <p class="title font-bold mb-0">{{listEndingData?.title}}</p>
                </div>
              </div>
              <div class="d-flex col-12 exemplar-listing" *ngFor="let data of addedMetadataList; let i=index;">

                <div class="col-10 text-wrapped px-0">
                  <div class="float-left col-num">
                    <p class="text-wrapped title font-bold mb-0">{{i+1}}.</p>
                  </div>

                  <div class="float-left col-data">
                    <p class="title font-bold">{{(data.name) ? data.name : data?.title}}</p>
                    <p [innerHtml]="getHtml(data, 'metadata_value')"></p>
                  </div>
                </div>

                <div class="col-2 text-right px-0">
                  <button class="btn btn-icon tooltip top top-right position-relative d-inline-block custom-icon-size"
                    data-tooltip="Delete metadata" [attr.aria-label]="'Delete metadata'" id="deleteMetadata_{{i+1}}"
                    (click)="onDeleteEvent(data.metadata_id)">
                    <em class="material-icons-outlined" aria-hidden="true">delete</em>
                  </button>
                </div>
              </div>
            </section>


          </aside>
        </div>
      </div>
    </ng-container>
  </modal-div>

</app-modal>
<!--ADD ADDITIONAL METADATA MODAL ENDS-->

<!-- edit additional metadata starts -->
<app-modal [modalId]="'editAddMetadata'" [modalContentId]="'editAddMetadataContent'"
  [showCloseAlert]="editMetadataForm.dirty" [modalSize]="'small'" (closeEvent)="onCancel($event)">
  <modal-div class="title-text">
    Edit Metadata
  </modal-div>

  <modal-div class="body-content">
    <app-preloader *ngIf="loading===true" [loaderText]="'Loading Additional Metadata List'" class="w-100 position-fixed preloader-backdrop"></app-preloader>
   <ng-container *ngIf="additionalMetadata && loading===false">
      <form [formGroup]="editMetadataForm">
        <div class="row">
          <div class="form-group col-lg-12 col-sm-12">
            <p class="font-bold" id="editAddMetadataContent">You can edit the value for this Metadata Key.</p>
            <label for="editKeyname" class="font-bold" id="editKeynameLabel">Key name</label>
            <select class="custom-select form-control" id="editKeyname"
              [formControl]="editMetadataForm.controls['metadataKey']" [ngModel]="additionalMetadata?.name"
              (ngModelChange)="additionalMetadata ? additionalMetadata.name=$event : '';"
              aria-labelledby="editKeynameLabel editKeynameHelp" disabled="true">
              <option selected="" [ngValue]="additionalMetadata.name">{{additionalMetadata?.name}}</option>
            </select>

            <div class="error--txt"
              *ngIf="editMetadataForm.controls['metadataKey'].hasError('required') && editMetadataForm.controls['metadataKey'].touched">
              <div role="alert">
                <p class="font-bold m-0 d-flex align-items-center mt-1">
                  <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                  Metadata Key Name Required.
               </p>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group col-lg-12 col-sm-12 px-0">
          <label for="assetDescription" class="font-bold" id="assetDescriptionLabel">Value <span class="mandatory"
              >*</span></label>
          <app-dynamic-form-field name="metadataValue" ngDefaultControl
            [formControl]="editMetadataForm.controls['metadataValue']"
            [field_type_id]="additionalMetadata ? additionalMetadata.field_type_id : ''"
            [disabled]="(additionalMetadata?.name) ? false : true" [ngModel]="additionalMetadata?.metadata_value"
            (ngModelChange)="currentValue=$event;checkCustomValidation()" [clearFieldValue]=false
            [selectedMetadata]="additionalMetadata"></app-dynamic-form-field>
          <div class="error--txt"
            *ngIf="editMetadataForm.controls['metadataValue'].hasError('required') && editMetadataForm.controls['metadataValue'].touched">
            <div role="alert">
              <p class="font-bold m-0 d-flex align-items-center mt-1">
                <span class="material-icons-outlined font-4x" aria-hidden="true">warning</span> <span class="sr-only">Error</span>
                Metadata Value Required.
             </p>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </modal-div>

  <modal-div class="footer-buttons">
    <button type="button" class="btn btn-primary btn-sm" (click)="editMetaData($event)" id="editAddMetadataBtn"
      [disabled]="(checkFormValidation()===false) || (formValid===false)" data-dismiss="modal">Update</button>
  </modal-div>
</app-modal>

<!-- edit additional metadata ends -->
